module.exports = __webpack_public_path__ + "43fe2cb101fe574409ab392995a0eef9.png";